import SerImage1 from '../assets/img/Services/Usluga-4-FASADE.jpg';
import SerImage2 from '../assets/img/Services/Fliesenarbeiten.jpg';
import SerImage3 from '../assets/img/Services/Innenarum-des-hauses.jpg';
import SerImage4 from '../assets/img/Services/Restauraten.jpg';
import SerImage5 from '../assets/img/Services/Trockenbau-und-akustikdecken.jpg';
import SerImage6 from '../assets/img/Services/Veskovic-pergola.png';

const DataServices = [
    {
        id: 1,
        title: 'STUCK UND FASSADEN',
        image: SerImage1
    },
    {
        id: 2,
        title: 'TROCKENBAU UND AKUSTIKDECKEN',
        image: SerImage5
    },
    {
        id: 3,
        title: 'RESTAURATOREN',
        image: SerImage4
    },
    {
        id: 4,
        title: 'FLIESENARBEITEN',
        image: SerImage2
    },
    {
        id: 5,
        title: 'VESKOVIC PERGOLA',
        image: SerImage6
    },
    {
        id: 6,
        title: 'INNENRAUM DES HAUSES',
        image: SerImage3
    },
]


export default DataServices
